<app-entity-form-tags
  [type]="type"
  [id]="id"
  [tags]="tags"
  [label]="tagsFieldLabel"
  [autoSave]="autoSave"
  [showModifiedMsg]="showModifiedMsg"
  #field
></app-entity-form-tags>

<ng-container *ngIf="showSuggesttedTags">
  <ng-container *ngIf="tags$ | async; let tags">
    <div class="mb-2" *ngIf="tags.length" i18n>Suggested Tags</div>
    <mat-chip-list>
      <mat-chip *ngFor="let tag of tags" (click)="field.add(tag)" class="clickable">
        <button class="mat-chip-btn mr-2" type="button"><i class="far fa-plus"></i></button>
        {{ tag }}
        <!-- TV4-6241: Remove tag from all entities of this type -->
        <button
          class="mat-chip-btn ml-2 tag-remove-all-btn"
          type="button"
          matTooltip="Remove this tag everywhere"
          i18n-matTooltip
          (click)="$event.stopPropagation(); onRemoveSuggestedTag(tag)"
        >
          <i class="far fa-times"></i>
        </button>
      </mat-chip>
    </mat-chip-list>
  </ng-container>
</ng-container>
